import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { graphql } from "@repo/graphql-types/gql";

import { AppointmentTypeReviewForm } from "@/components/appointment/type/appointment-type-review-form";
import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";
import { FlowHeader } from "@/components/ui/flow-header/flow-header";
import { Page } from "@/components/ui/layout/page/page";
import { RoundedLayout } from "@/components/ui/layout/rounded-layout";
import { FullPageSpinner } from "@/components/ui/loading/full-page-spinner";
import { useGraphQL } from "@/hooks/use-graphql";

import type { JSX } from "react";

const reviewSearchSchema = z.object({
  /** Agendas recém-criadas pelo fluxo de nova agenda, já marcadas para vínculo. */
  codAgendas: z.array(z.coerce.number()).optional(),
});

const GetAppointmentTypeReviewPageQuery = graphql(`
  query GetAppointmentTypeReviewPageQuery($codUsuario: Int!) {
    ...AppointmentTypeReviewQueryFragment
  }
`);

const CreateAppointmentTypeReviewPage = (): JSX.Element => {
  const { user } = Route.useRouteContext();
  const { codAgendas } = Route.useSearch();

  const queryResult = useGraphQL(GetAppointmentTypeReviewPageQuery, {
    codUsuario: Number(user.codUsuario),
  });

  const { data } = queryResult;

  return (
    <RoundedLayout>
      <FlowHeader>
        <FlowHeader.Actions>
          <FlowHeader.BackButton />
          <FlowHeader.Title
            title="Criar tipo de atendimento"
            description="Essas configurações ajudam pacientes a agendar sozinhos pelo site ou por telefone."
          />
        </FlowHeader.Actions>
      </FlowHeader>
      <Page>
        <AsyncDataWrapper {...queryResult}>
          {data ? (
            <AppointmentTypeReviewForm data={data} preSelectedSchedules={codAgendas} />
          ) : (
            <FullPageSpinner />
          )}
        </AsyncDataWrapper>
      </Page>
    </RoundedLayout>
  );
};

export const Route = createFileRoute(
  "/settings/schedule-options/appointment-types/create/review",
)({
  validateSearch: reviewSearchSchema,
  component: CreateAppointmentTypeReviewPage,
});
